import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRockClimbingNormalMedium = React.forwardRef(
  ({ color = "currentColor", size = 32, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2.693 4.293L1.653 3.6.267 5.68l1.04.693c.44.293.698 1.05.36 1.949-.091.239-.173.499-.226.766l-.09.446a2.029 2.029 0 00-.036.145L.18 15.02c-.12.565-.18 1.14-.18 1.718v.69a7.572 7.572 0 0011.487 6.482l2.105-1.272 14.31 2.191A3.56 3.56 0 0032 21.31a9.334 9.334 0 00-1.803-5.514l-.818-1.118a10.581 10.581 0 00-2.854-2.674L16.53 5.637a3.917 3.917 0 00-5.629 1.595L8.601 11.98l-.253-.379-.839-1.257a5.075 5.075 0 00-3.243-2.165c.196-1.388-.187-2.961-1.573-3.885zm.94 6.508l.014.003.038-.19c.706.11 1.341.511 1.744 1.116l6.132 9.213-1.366.826A5.072 5.072 0 012.5 17.428v-.691c0-.403.042-.804.126-1.198zm10.422 9.378l-1.773-2.666L29.4 20.147c.066.382.1.77.1 1.162a1.06 1.06 0 01-1.22 1.048zm-3.648-5.484l-.2-.3 2.945-6.072a1.417 1.417 0 012.036-.577l1.169.745-1.768 3.534 2.236 1.119 1.652-3.303 1.42.904-1.574 3.147 2.236 1.118 1.457-2.915 3.166 2.016a8.085 8.085 0 012.18 2.043l.818 1.118c.043.058.084.117.125.177z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRockClimbingNormalMedium;
